module.exports = __webpack_public_path__ + "static/media/knife-smash.5ad40857.jpg";